import router from '../router/router';
import { RouterView } from '@/models/enums';

export function isSignFileView(): boolean {
  return router.currentRoute.name === RouterView.SignFiles;
}

export function isUnregUserView(): boolean {
  return [`${RouterView.ViewDocUnregUser}`].includes(router.currentRoute.name || '');
}

export function wait(ms): Promise<void> {
  return new Promise(resolve => setTimeout(() => resolve(), ms));
}
